import axios, { AxiosRequestConfig } from 'axios';
import { authRequestInterceptor, authResponseErrorInterceptors, authResponseSuccessInterceptors } from '../interceptors/auth.interceptor';
import {
   cancelTokenRequestInterceptor as abortableRequestInterceptor,
   cancelTokenResponseErrorInterceptors as abortableResponseErrorInterceptors,
   cancelTokenResponseSuccessInterceptors as abortableResponseSuccessInterceptors,
} from '../interceptors/cancel-token.interceptor';
import { errorResponseErrorInterceptor, errorResponseSuccessInterceptor } from '../interceptors/error.interceptor';
import { localizationRequestInterceptor } from '../interceptors/localization.interceptor';

//#region Cancel Token
export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
   cancelable?: boolean;
}

const abortControllerDict: { [request: string]: AbortController } = {};

function addAbortController(request?: string, controller?: AbortController) {
   if (!request || !controller) return;
   abortControllerDict[request] = controller;
}
function removeAbortController(request?: string) {
   if (!request) return;
   if (abortControllerDict[request]) delete abortControllerDict[request];
}
//#endregion

//#region Configs
const baseConfig: AxiosRequestConfig = {
   baseURL: import.meta.env.VITE_APP_API_BASE_URL,
};

const largeFileConfig: AxiosRequestConfig = {
   baseURL: import.meta.env.VITE_APP_API_BASE_URL_FOR_LARGE_FILES,
};

const cacheFirstConfig: AxiosRequestConfig = {
   headers: {
      'Cache-Control': 'force-cache',
   },
};
//#endregion

//#region Axios instance
const http = axios.create(baseConfig);

const publicHttp = axios.create({ ...baseConfig });
//#endregion

//#region Interceptors

http.interceptors.request.use(authRequestInterceptor);
http.interceptors.request.use(localizationRequestInterceptor);
publicHttp.interceptors.request.use(localizationRequestInterceptor);
http.interceptors.request.use(abortableRequestInterceptor);
publicHttp.interceptors.request.use(abortableRequestInterceptor);

http.interceptors.response.use(authResponseSuccessInterceptors, authResponseErrorInterceptors);
publicHttp.interceptors.response.use(authResponseSuccessInterceptors, authResponseErrorInterceptors);
http.interceptors.response.use(errorResponseSuccessInterceptor, errorResponseErrorInterceptor);
publicHttp.interceptors.response.use(errorResponseSuccessInterceptor, errorResponseErrorInterceptor);
http.interceptors.response.use(abortableResponseSuccessInterceptors, abortableResponseErrorInterceptors);
publicHttp.interceptors.response.use(abortableResponseSuccessInterceptors, abortableResponseErrorInterceptors);
//#endregion

export { abortControllerDict, addAbortController, cacheFirstConfig, http, largeFileConfig, publicHttp, removeAbortController };
